/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import template from './print-line-item-list-page.component.html';
import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {PrintLineItemApiService, PrintLineItemModel} from './print-line-item-api.service';
import {AppSharedModule} from '../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-print-line-item-list-page',
  template
})
export class PrintLineItemListPageComponent implements OnInit {
  readonly itemStateName = 'app.adv.print-line-items.print-line-item';
  readonly advertiserItemStateName = 'app.adv.advertisers.advertiser';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'startDate'},
    {param: 'endDate'},
    {param: 'advertiser', label: 'advertiser'}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<PrintLineItemModel>(
    inject(PrintLineItemApiService),
    {listId: 'fullPrintLineItemList', baseTable: 'printLineItem'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
